import { faFacebookSquare } from '@fortawesome/free-brands-svg-icons/faFacebookSquare';
import { faInstagram } from '@fortawesome/free-brands-svg-icons/faInstagram';
import { faTwitter } from '@fortawesome/free-brands-svg-icons/faTwitter';
import { faYoutube } from '@fortawesome/free-brands-svg-icons/faYoutube';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import styled from 'styled-components';
import { COLOR } from '../../../../styles/colors';

const SocialWrapper = styled.div`
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  color: ${COLOR.white};
  white-space: nowrap;
  text-transform: uppercase;
`;

const SocialUrl = styled.a`
  margin: 0 20px;
  min-width: 24px;
  color: ${COLOR.white};
  text-decoration: none;

  @media only screen and (min-width: 360px) {
    margin: 0 20px;
  }

  &:hover {
    opacity: 0.6;
  }

  &:first-child {
    margin-left: 0;
  }
`;

const StyledFontAwesomeIcon = styled(FontAwesomeIcon)`
  font-size: 32px;

  @media only screen and (max-width: 980px) {
    font-size: 24px;
  }
`;

const SOCIAL_DATA = [
  {
    id: 1,
    name: 'Facebook',
    url: 'https://www.facebook.com/maxpreps/',
    icon: faFacebookSquare
  },
  {
    id: 2,
    name: 'Twitter',
    url: 'https://twitter.com/MaxPreps',
    icon: faTwitter
  },
  {
    id: 3,
    name: 'YouTube',
    url: 'https://www.youtube.com/user/Maxprepssports',
    icon: faYoutube
  },
  {
    id: 4,
    name: 'Instagram',
    url: 'https://www.instagram.com/maxpreps/?hl=en',
    icon: faInstagram
  }
];

const SocialLinks = () => (
  <SocialWrapper>
    {SOCIAL_DATA.map(item => (
      <SocialUrl
        key={item.id}
        href={item.url}
        target="_blank"
        aria-label={`Go to MaxPreps ${item.name} page`}
        rel="noopener noreferrer"
      >
        <StyledFontAwesomeIcon icon={item.icon as any} />
      </SocialUrl>
    ))}
  </SocialWrapper>
);

export default SocialLinks;
